import React, { Component } from 'react';
import classnames from 'classnames';
import { ClassifyContainer } from './style';
import {objDeepCopy} from '../../../utils/tool'
import {observer} from 'mobx-react';
import InfoService from '../../../services/InfoService'
import unit_institution from '../../../store/asset_institution/unit_institution';

@observer
class ClassifyItem extends Component {
  constructor( props ) {
    super(props);
    const {ClassifyItem} = this.props.store;
    if (ClassifyItem) {
      this.state = ClassifyItem
    } else {
      this.state = {
        items: [],
      }
    }
  }

  componentDidMount() {
    const {ClassifyItem} = this.props.store;
    if(!ClassifyItem){
      this.setClassifyItems()
    }
  }

  setClassifyItems=()=>{
    InfoService.getCategoryByPublishSource({"publishSource": unit_institution.publishSource}).then(res=>{
      if(res && res.datas && res.datas.length>0){
        let assetTargetClassify = [
          {
            name: '不限',
            param: 0,
            actived: true,
            condition: {childrenCateId: 'none'},
            thirdCateIds:[]
          },
        ]
        for(let i=0;i<res.datas.length;i++){
          const {name,id,thirdCateIds} = res.datas[i]
          let obj = {
            name,
            param:id,
            actived:false,
            condition:{childrenCateId:id},
            thirdCateIds:thirdCateIds
          }
          assetTargetClassify.push(obj)
        }
        this.setState({
          items: objDeepCopy(assetTargetClassify),
        })
      }
    })
  }

  handleClick = (item) => {
    let curItem = {};
    const {items} = this.state;
    items.forEach((value, index) => {
      value.actived = false;
      if (index === item.index) {
        value.actived = true;
        curItem = value;
      }
    })
    this.setState({
      items,
    });

    // 暂存数据
    const {saveCurrData, addCondition} = this.props.store;
    const { closeFilter, defaultIndex, changeCurrFilterItems  } = this.props;
    saveCurrData('ClassifyItem', this.state);

    // 增加选择条件
    addCondition(curItem.condition, true);
    closeFilter();
    changeCurrFilterItems(defaultIndex, item.name);
  }

  render() {
    const {items} = this.state;
    return (
      <ClassifyContainer>
       <div className="classify-content">
         {
           items && items.length>0 && items.map((item, index) => {
             return (
               <div
                 key={item.name}
                 className={classnames(["classify-item", {
                   'actived': item.actived,
                 }])}
                 onClick={() => {
                   this.handleClick({
                     index,
                     id: item.param,
                     name: item.name,
                   })
                 }}
               >{item.name}</div>
             )
           })
         }
         {/*占位符 最后一行左对齐*/}
         <div className="classify-item none"></div>
         <div className="classify-item none"></div>
       </div>
      </ClassifyContainer>
    );
  }
}

export default ClassifyItem;
